import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

// Initialize PostHog
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  capture_pageview: false, // We manually track SPA page views via PostHogPageView
  capture_pageleave: true,
  autocapture: true,
  persistence: "localStorage",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
